export const FETCH_PART = 'part/FETCH_PART';
export const RECEIVE = 'part/RECEIVE';
export const RECEIVE_PART_MODEL = 'part/RECEIVE_PART_MODEL';
